import { render } from "./LinkageSetPassword.vue?vue&type=template&id=8742d2d8&scoped=true&ts=true"
import script from "./LinkageSetPassword.vue?vue&type=script&lang=ts"
export * from "./LinkageSetPassword.vue?vue&type=script&lang=ts"

import "./LinkageSetPassword.vue?vue&type=style&index=0&id=8742d2d8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src599522923/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8742d2d8"]])

export default __exports__